import React from "react";

import NewInput from "../../../../../shared/forms/NewInput";
import useSnackbar from "../../../../../shared/Snackbar/store";
import useCalulatorStore from "../../store";

const ZipcodeInput = ({
    setMayCalculate = null,
    setZipcode,
    localZipcode,
    setZipcodeError,
    zipcodeError,
    skipAvailabilityValidation = false,
}) => {
    const [checkZipcode] = useCalulatorStore((state) => [state.checkZipcode]);
    const { notify } = useSnackbar();
    const onChangeZipcode = (event) => {
        setZipcode(event.target.value);
        if (!skipAvailabilityValidation && event.target.value.length === 5) {
            checkZipcode(event.target.value, notify);
        }
        setMayCalculate && setMayCalculate(true);
    };

    return (
        <>
            <NewInput
                name="zipcode"
                placeholder="Postleitzahl"
                value={localZipcode}
                onChange={onChangeZipcode}
                validation="zipcode"
                onError={() => setZipcodeError(true)}
                forceError={zipcodeError}
                onErrorSolved={() => {
                    setZipcodeError(false);
                }}
                required
            />
        </>
    );
};

export default ZipcodeInput;
